import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {SelectedAssetModule} from '../../../sc-selected-asset/src/app/selected-asset/selected-asset.module';
import {AddressMapModule} from '../../../sc-address-map/src/app/address-map/address-map.module';
import {StreetAddressModule} from '../../../sc-street-address/src/app/street-address/street-address.module';
import {AvlAnimationGmapModule} from '../../../sc-avl-animation-gmap/src/app/avl-animation-gmap/avl-animation-gmap.module';
import {AvlAtLocationGmapModule} from '../../../sc-avl-at-location-gmap/src/app/avl-at-location-gmap/avl-at-location-gmap.module';
import {AvlCurrentLocationGmapModule} from '../../../sc-avl-current-location-gmap/src/app/avl-current-location-gmap/avl-current-location-gmap.module';
import {AvlSpeedModule} from '../../../sc-avl-speed/src/app/avl-speed/avl-speed.module';
import {AvlSpeedGmapModule} from '../../../sc-avl-speed-gmap/src/app/avl-speed-gmap/avl-speed-gmap.module';
import {AvlTraceModule} from '../../../sc-avl-trace/src/app/avl-trace/avl-trace.module';
import {AvlTraceGmapModule} from '../../../sc-avl-trace-gmap/src/app/avl-trace-gmap/avl-trace-gmap.module';
import {BoundaryModule} from '../../../sc-boundary/src/app/boundary/boundary.module';

@NgModule({
  declarations: [
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    AddressMapModule,
    SelectedAssetModule,
    StreetAddressModule,
    AvlAnimationGmapModule,
    AvlAtLocationGmapModule,
    AvlCurrentLocationGmapModule,
    AvlSpeedModule,
    AvlSpeedGmapModule,
    AvlTraceModule,
    AvlTraceGmapModule,
    BoundaryModule
  ],
  providers: []
})
export class AppModule {

  constructor() {}

  // ngDoBootstrap needs to do nothing when exporting custom elements so that the normal Angular app bootstrap doesn't take place
  ngDoBootstrap() {}
}

